import React, { useState } from 'react';
import "./css/cookiebanner.css"


export default function CookieBanner() {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAccept = () => {
    setIsAccepted(true);
    localStorage.setItem('cookiesAccepted', 'true'); // Store the user's choice in localStorage
  };

  const handleReject = () => {
    setIsAccepted(true);
    localStorage.setItem('cookiesAccepted', 'false'); // Store rejection
  };

  // Check if the user has already accepted or rejected the cookies
  React.useEffect(() => {
    const cookiesStatus = localStorage.getItem('cookiesAccepted');
    if (cookiesStatus === 'true') {
      setIsAccepted(true);
    }
  }, []);

  if (isAccepted) return null;

  return (
    <div className="cookie-banner">
      <p>
        We use cookies to improve your experience.By accepting, you agree to our use of such cookies.<a href="./Docs/Privacy Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </p>
      <button onClick={handleAccept}>Accept</button>
      <button onClick={handleReject}>Reject</button>
    </div>
  );
}
